/* global YT */

const selector = '.video__trigger:not(.video__trigger--margin)';

/**
 *  Video with custom trigger
 *
 * @param {HTMLElement} el
 */
export const Video = (el) => {
  /**
   * Play the video
   *
   * @param {HTMLElement} triggerEl
   */
  const playVideo = (triggerEl) => {
    const videoId = triggerEl.dataset.youtubeid;

    const onPlayerReady = (playerReadyEv) => {
      playerReadyEv.target.playVideo();
      triggerEl.parentNode.classList.add('video__holder--playing');
    };

    // Create holder for iframe and load player
    const videoHolder = document.createElement('div');
    videoHolder.id = videoId;
    triggerEl.parentNode.appendChild(videoHolder);

    return new YT.Player(videoId, {
      videoId,
      playerVars: {
        rel: 0,
      },
      events: {
        onReady: onPlayerReady,
      },
    });
  };

  /**
   * Asynchronously add the Youtube API
   */
  const addYoutubeIframeApiScript = () => {
    if (window.onYouTubeIframeAPIReady) return;

    const script = document.createElement('script');
    script.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.querySelector('script');
    firstScriptTag.parentNode.insertBefore(script, firstScriptTag);

    window.onYouTubeIframeAPIReady = () => {
      document.dispatchEvent(new CustomEvent('onYouTubeIframeAPIReady'));
    };
  };

  document.addEventListener('onYouTubeIframeAPIReady', () => {
    el.addEventListener('click', () => {
      playVideo(el);
    });
  });

  addYoutubeIframeApiScript();
};

export default function init(scope = document) {
  scope.querySelectorAll(selector).forEach((el) => Video(el));
}
